import { DialogContent, DialogTitle, Stack } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { paperGoodsReceiptBusiness } from "api/bussiness/paper-material/paper-goods-receipt";
import { invalidatePaperCatalogCache } from "api/cached";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IAddPaperGoodsReceipt } from "mobx-stores/_models/paper-inventory/paper-goods-receipt/paper-goods-receipt";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getAddPaperGoodsReceiptSchema } from "./schema";

export const AddPaperGoodsReceipt = observer(() => {
  const queryClient = useQueryClient();
  const {
    paperInventoryManagement: {
      paperGoodsReceiptStore: { openNew, getPaperGoodsReceipt, setProp },
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
  } = useForm<IAddPaperGoodsReceipt>(getAddPaperGoodsReceiptSchema(), {
    receiptDate: dateTimeToUTCString(dayjs()),
    items: [
      {
        materialId: "",
        amount: 0,
        wareHouse: "",
        brand: "",
        serialNumber: "",
        supplier: "",
        document: "",
        note: "",
        origin: "",
      },
    ],
  });

  const saveHandler = useCallback(
    async (data: IAddPaperGoodsReceipt) => {
      try {
        await paperGoodsReceiptBusiness.add(data);
        await invalidatePaperCatalogCache(queryClient);
        await getPaperGoodsReceipt();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getPaperGoodsReceipt, queryClient, setProp],
  );

  const itemsControl = useMemo(() => {
    return getControl("items").children;
  }, [getControl]);

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm nhập kho</DialogTitle>
      <DialogContent>
        <Stack sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
          {itemsControl && itemsControl.length > 0 && (
            <DynamicFormArray
              children={itemsControl}
              controlSpacing={2}
            ></DynamicFormArray>
          )}
        </Stack>
      </DialogContent>
    </DialogForm>
  );
});
